import { NARRATIVE_AUTHOR_FRAGMENT } from '@/components/DeprecatedNarrativeAuthor';
import { NARRATIVE_OWNER_FRAGMENT } from '@/components/NarrativeAuthor';
import { gql } from '@/utilities/gql';
import { makeGqlQuery } from '@/utilities/gqlQuery';

const QUERY = gql(
  `
  query getExistingNarrative($companyId: String!, $loggedIn: Boolean!) {
    Company(id: $companyId) {
      data {
        currencyInfo
      }
      analysisValue {
        lastSharePrice
        npvPerShare
      }
      myValuation @include(if: $loggedIn) {
        fairValue
        narrative {
          id
          primaryCount
          valuations {
            fairValue
            createdAt
          }
          author {
            ...NarrativeAuthorFields
          }
          owner {
            ...NarrativeOwnerFields
          }
        }
      }
    }
  }
`,
  [NARRATIVE_AUTHOR_FRAGMENT, NARRATIVE_OWNER_FRAGMENT]
);

export const useExistingNarrative = makeGqlQuery(QUERY, {
  tags: ['narrative'],
});
